import styled from "styled-components";
import { Container } from "../../../components/navbar/Nav.styles";
import { CaptionText } from "../../home/components/AboutSession";

const Value = () => {
  return (
    <Container>
      <ValueCaption>Core Values</ValueCaption>
      <WrapCirlce>
        <div outline="outline">
          <h5 className="circle-text">
            Customer <span>Commitment</span>
          </h5>
        </div>
        <div>
          <h5>Integrity</h5>
        </div>
        <div>
          <h5>Reliability</h5>
        </div>
      </WrapCirlce>
    </Container>
  );
};

export default Value;

export const ValueCaption = styled(CaptionText)`
  text-align: left;

  @media screen and (max-width: 579px) {
    text-align: center;
  }
`;
export const WrapCirlce = styled.div`
  display: flex;
  justify-content: center;

  div {
    transform: translateY(-5rem);
    height: 360px;
    width: 360px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  h5 {
    font-size: 24px;
  }
  div:nth-of-type(1) {
    background-color: #e9e9fc;
  }
  div:nth-of-type(2) {
    background-color: #fff7e8;
  }
  div:nth-of-type(3) {
    background-color: #ffdce2;
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: center;
    gap: 3rem;
  }
  @media screen and (max-width: 579px) {
    margin-top: 6rem;
    margin-bottom: 6rem;
    h5 {
      font-size: 1.5rem;
    }
    .circle-text {
      margin-left: 2rem;
    }
    span {
      display: block;
      margin-left: -1rem;
    }
    div {
      transform: translateY(-5rem);
      height: 240px;
      width: 240px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
